import { EnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import * as userMeEffects from './user-me.effects';
import { userMeKey } from './user-me.state';
import { userMeReducer } from './user-me.reducer';

export function provideUserMeStore(): EnvironmentProviders[] {
  return [provideState({ name: userMeKey, reducer: userMeReducer }), provideEffects(userMeEffects)];
}
